import { CustomerLocationsView } from './CustomerLocationsView';

export const CustomerLocationsComponentMap = {
  CustomerLocationsView,
};

export type CustomerLocationsModalViewType = keyof typeof CustomerLocationsComponentMap;
